/* eslint-disable no-console */
import { hideLoading, showLoading } from 'react-redux-loading-bar';
import externalApi from '../../../utils/externalApi';

const ActionType = {
  RECEIVE_JOKE: 'RECEIVE_JOKE',
};

function receiveJokeActionCreator(joke) {
  return {
    type: ActionType.RECEIVE_JOKE,
    payload: {
      joke,
    },
  };
}

function asyncReceiveJoke() {
  return async (dispatch) => {
    dispatch(showLoading());
    try {
      const joke = await externalApi.getRandomJoke();
      dispatch(receiveJokeActionCreator(joke));
    } catch (error) {
      console.log('Failed to load joke');
    }
    dispatch(hideLoading());
  };
}

export { ActionType, receiveJokeActionCreator, asyncReceiveJoke };
